<template>
	<!-- :style="'background:'+bottomConfig.backgroundColor" -->
	<div class="bottom-wrapper" >
		<div class="container">
			
			<div class="item-c">
				<div class="item" v-for="(item,index) in currentRouterList.router" :key="index" @click="go(item)">
					{{ item.name }} <span v-if="index!==currentRouterList.router.length-1">|</span>
				</div>
			</div>
		</div>
		<div style="margin-top: 20px;display: flex;align-items: center;justify-content: center;color: #999;font-size: 12px;">
			<a href="https://beian.miit.gov.cn" target="_blank" style="margin-left: 5px;color: #999;">浙ICP备20006038号</a>
		</div>
	</div>
</template>

<script>
export default { 
  name: 'Bottom',
  components: {  },
  props:{
  		lang:{},
  },
  data() {
    return {
		currentLanguage:"",
		routers: [
			{language:"zh",router:[{link:'',name:'首页'},{link:'/about',name:'关于我们'},{link:'/news',name:'新闻中心'},{link:'/contact',name:'联系我们'}]},
			{language:"en",router:[{link:'',name:'Home'},{link:'/about',name:'About Us'},{link:'/news',name:'News'},{link:'/contact',name:'Contact'}]},
			{language:"ja",router:[{link:'',name:'ホーム'},{link:'/about',name:'サイトマップ'},{link:'/news',name:'インフォメーション'},{link:'/contact',name:'お問い合わせ'}]}
      	],
		indexConfig:{
			companInfo:{backgroundColor:'#000',image:[{url:''}],title:''},
			bottomInfo:{image:[{url:''}]}
		},
		bottomConfig:{
			leftContent:{},
			centerContent:{},
			rightContent:{},
			rightContent1:{},
		},
		imageUrl:''
	}
  },
  computed:{
	currentRouterList(){
		return this.routers.find(item=>{
			return this.lang===item.language
		})
	}
  },
  created(){
	// this.getImage()
	// this.getBottomConfig()
  },
  methods:{
	async getBottomConfig(){
		const res=await this.$http.post('/bottomConfig',{la:this.lang})
		this.bottomConfig = res.data[0]||{}
	},
	go(item){
		this.$router.push(item.link+'/'+this.lang)
	},
	async getImage(){
		const res=await this.$http.post('/indexConfig',{la:this.lang})
		this.indexConfig = res.data||{
			companInfo:{backgroundColor:'#000',image:[{url:''}],title:''},
			bottomInfo:{image:[{url:''}]}
		}
		if(this.indexConfig.bottomInfo&&this.indexConfig.bottomInfo.image.length!==0){
			this.imageUrl = this.indexConfig.bottomInfo.image[0].url
		}
		
	},
	getLanguage () {	    
	    this.currentLanguage=this.lang;
		this.getBottomConfig()
	},
	goUrl(url){
		console.log(this.lang)
		this.$router.push(url+'/'+this.lang)
	},
	openNewUrl(url){
		window.location.href=url
	}
  },
  watch: {
  		// 如果路由有变化，会再次执行该方法
  		"$route": "getLanguage"
  }
}  
</script>

<style lang="scss" scope>
	.bottom-wrapper{
		background: 100%;
		min-height: 148px;
		padding:20px 0;
		.container{
			width: 100%;
			border-top:4px solid rgba(0, 0, 0, 0.6);
			margin: 0 auto;
			padding: 0 20px;
			box-sizing: border-box;
			display: flex;
			flex-direction: row;
			justify-content: center;
			.item-c{
				
				width: 1400px;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				padding-top:20px;
				.item{
					margin-right: 20px;
					cursor: pointer;
				}
			}
		}
	}
</style>
